var login_ajax = require( './login-ajax' ),
	account_menu = require( './header-account-menu' );

var login_popup = ( function( $ ) {

	var $form;

	var _init = function() {
		var data = {
			action: 'crate_get_header_login',
			nonce: ScriptData.crate_get_header_login_nonce
		};

		$.get( ScriptData.ajaxurl, data, _maybe_init );
	};

	var _maybe_init = function( response ) {
		var $header = $( '#header' );

		if ( response.html ) {
			$header.find( '#login' ).replaceWith( response.html );

			account_menu.init();

			if ( !response.is_auth ) {
				$form = $( '#vn_popup_loginform' );

				if ( $form.length > 0 ) {
					$header.find( '#login .login-link' ).on( 'click', _toggle_popup );
					$form.on( 'submit', _login );
				}
			}
		} else {
			console.log( 'No html' )
			console.log( response );
		}
	};

	var _toggle_popup = function ( e ) {
		var $login_popup = $( this ).next( '#login-popup' );

		$( '#header' ).find( '#login .login-link' ).toggleClass( 'open' );

		$login_popup.slideToggle();

		if ( ! $login_popup.hasClass( 'done' ) ) {

			setTimeout( function() {
				$login_popup.addClass( 'done' );
			}, 500 );
		} else {
			$login_popup.removeClass( 'done' );
		}

		e.preventDefault();
	};

	var _login = function( e ) {
		e.preventDefault();

		login_ajax.loading( $( '#login-popup' ) );

		login_ajax.login( $form, _login_response );
	};

	var _login_response = function( response ) {
		login_ajax.loaded( $( '#login-popup' ) );

		if ( !response.can_view.content ) {
			var message = "We have not found your login details. Please try again, or perhaps you want to <a href='https://esra.multiregistration.com/login?lost_password=1'>reset your password?</a>";

			if ( 'expired_member' === response.userDetails.status_description ) {
				message = "It looks like your membership has expired, please <a href='https://esra.multiregistration.com/' target='_blank'>renew your membership</a> before logging in.";
			}

			$form.find( '.top_error_login' ).html( message ).fadeIn();
		} else {
			$form.find( '.top_error_login' ).html( 'You are now logged in... redirecting...' ).fadeIn();
			location.href = ScriptData.login_redirect;
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = login_popup;